import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { SponsorData } from '~admin/model/sponsor-data';
import { mapSponsorData } from '~admin/model/sponsor-data.mapper';
import { SponsorCreateRequest } from '~client/model/admin/sponsor-create-request';
import { SponsorResponse } from '~client/model/sponsor-response';
import { OneArgTask, rxTask } from '~common/helper/mobx-tasks';

export type CreateSponsorTask = OneArgTask<SponsorCreateRequest, SponsorData>;

const performCreateSponsor = (request: SponsorCreateRequest): Observable<SponsorResponse> =>
  apiClient.adminSponsorController.createSponsor$(request);

export const createSponsorTaskFactory = (): CreateSponsorTask =>
  rxTask((request: SponsorCreateRequest) =>
    performCreateSponsor(request).pipe(map(mapSponsorData)),
  );



// WEBPACK FOOTER //
// ./interactor/sponsor/perform-create-sponsor.ts